import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TekstResourcePipe } from '../../pipes/tekstresource.pipe';

@Component({
  selector: 'bom-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit {
  @Input()
  type: 'info' | 'success' | 'successAlert' | 'warning' | 'warningAlert' | 'error' = 'info';

  @Input()
  showIcon?: boolean;

  @Input()
  titleKey?: string;

  @Input()
  titleHtml?: string;

  @Input()
  descriptionKey?: string;

  @Input()
  descriptionHtml?: string;

  @Input()
  descriptionHtmlSanitized?: string;

  @Input()
  showWarningIcon?: boolean;

  @Output()
  closeEvent?: EventEmitter<void> = new EventEmitter();

  showCloseButton = false;
  titleValue?: string;
  descriptionValue?: string;

  constructor(private tekstResourcePipe: TekstResourcePipe) {}

  ngOnInit() {
    this.showCloseButton = this.closeEvent.observers.length > 0;

    if (this.titleKey) {
      this.titleValue = this.tekstResourcePipe.transform(this.titleKey);
    }

    if (this.descriptionKey) {
      this.descriptionValue = this.tekstResourcePipe.transform(this.descriptionKey);
    }
  }

  close() {
    this.closeEvent.emit();
  }
}
